import React from "react";
import "react-vertical-timeline-component/style.min.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component/dist-modules";

const Timeline = () => {
  return (
    <div id="education" className="block mb-8">
      <h1 className="text-2xl font-bold text-white">Education</h1>
      <p className="font-light text-gray-400">My educational qualifications</p>

      <br />
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="2020 - 2024"
          iconStyle={{ background: "rgb(2, 23, 40)", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Guru Gobind Singh Indraprastha University
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            New Delhi, India
          </h4>
          <p>
            B.Tech, Computer Science & Engineering <br />
            <i>Grade: 9.69 CGPA</i>
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2017 - 2019"
          iconStyle={{ background: "rgb(2, 23, 40)", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Kendriya Vidyalaya, Andrews Ganj
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            New Delhi, India
          </h4>
          <p>
            Senior Secondary Education(Intermediate) <br />
            <i>Grade: 90%</i>
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2017"
          iconStyle={{ background: "rgb(2, 23, 40)", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Kendriya Vidyalaya, Andrews Ganj
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            New Delhi, India
          </h4>
          <p>
            Secondary Education(Matriculation) <br />
            <i>Grade: 10 CGPA</i>
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
      <div className="line"></div>
    </div>
  );
};

export default Timeline;
